import candidateApi from './api';
import authService from './authService';
const token = authService.getToken();

export const getProfile = async () => {
    try {
        const response = await candidateApi.get('/profile');
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const updateProfile = async (formData) => {
    try {
        const response = await candidateApi.post(`/profile/update`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;        
    } catch (error) {
        throw error;
    }
}

export const getProfileScore = async () => {
    try {
        const response = await candidateApi.get('/profile/completion');
        return response.data;
    }
    catch (error) {
        throw error;
    }
}


/* export const candidateService = {
  // Profile APIs
  getProfile: async () => {
    return await candidateApi.get('/candidate/profile');
  },

  updateProfile: async (profileData) => {
    return await candidateApi.post('/profile/update', profileData);
  },  
};
 */